import React, { useEffect, useState } from 'react';

import { CIDrawer, CIInlineAlert } from './CustomerIdentityShared';

const emptyForm = { group_key: '', name: '', description: '' };

/**
 * Edit site-scoped user group metadata (key, name, description).
 */
export default function CiUserGroupEditDrawer({
  open,
  group,
  onClose,
  onSave,
  busy,
  formError,
  onDismissError,
  t,
}) {
  const [form, setForm] = useState(emptyForm);

  useEffect(() => {
    if (group) {
      setForm({
        group_key: group.group_key || group.groupKey || '',
        name: group.name || '',
        description: group.description || '',
      });
    } else {
      setForm(emptyForm);
    }
  }, [group]);

  if (!open || !group) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    const group_key = form.group_key.trim();
    const name = form.name.trim();
    if (!group_key || !name) return;
    onSave({
      group_key,
      name,
      description: form.description.trim() || null,
    });
  };

  const msg = formError
    ? typeof formError === 'string'
      ? { kind: 'danger', text: formError }
      : formError
    : null;

  return (
    <CIDrawer
      open={open}
      title={`${t('userGroups.editGroup')}: ${group.name || ''}`}
      onClose={onClose}
    >
      <form onSubmit={handleSubmit}>
        <CIInlineAlert message={msg} onDismiss={onDismissError} className="mt-0" />
        <div className="mb-3">
          <label className="form-label" htmlFor="ci-ug-edit-key">
            {t('userGroups.groupKey')}
          </label>
          <input
            id="ci-ug-edit-key"
            className="form-control font-monospace"
            value={form.group_key}
            onChange={(e) =>
              setForm((f) => ({ ...f, group_key: e.target.value }))
            }
            autoComplete="off"
            required
          />
          <div className="form-text">{t('userGroups.groupKeyHelp')}</div>
        </div>
        <div className="mb-3">
          <label className="form-label" htmlFor="ci-ug-edit-name">
            {t('userGroups.name')}
          </label>
          <input
            id="ci-ug-edit-name"
            className="form-control"
            value={form.name}
            onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))}
            required
          />
        </div>
        <div className="mb-3">
          <label className="form-label" htmlFor="ci-ug-edit-desc">
            {t('userGroups.description')}
          </label>
          <textarea
            id="ci-ug-edit-desc"
            className="form-control"
            rows={3}
            value={form.description}
            onChange={(e) =>
              setForm((f) => ({ ...f, description: e.target.value }))
            }
          />
        </div>
        <div className="d-flex gap-2 justify-content-end pt-2">
          <button
            type="button"
            className="btn btn-outline-secondary"
            onClick={onClose}
            disabled={busy}
          >
            {t('common.cancel')}
          </button>
          <button type="submit" className="btn ci-btn-primary text-white" disabled={busy}>
            {busy ? t('common.saving') : t('userGroups.saveGroup')}
          </button>
        </div>
      </form>
    </CIDrawer>
  );
}
